import {
  GET_PUBLIC_ARTICLES,
  GET_PRIVATE_ARTICLES,
  ADMIN_DETAILS_ARTICLE,
  TOGGLE_ARTICLE,
  PUBLIC_DETAILS_ARTICLE,
  GET_ARTICLES_BY_TAG,
  GET_ARTICLES_BY_CATEGORY,
  GET_ARTICLE_BY_LINK,
  ADD_LIKE,
  TOGGLE_LIKE_ADDING,
  ARTICLES_LOADING,
  SAVE_DRAFT_START,
  SAVE_DRAFT_SUCCESS,
  SAVE_DRAFT_ERROR,
  PUBLISH_DRAFT,
  LINK_ARTICLES,
  UNLINK_ARTICLES,
} from "../actions/types";

const initialState = {
  all_public_articles: [],
  admin_article_details: {},
  public_article_details: {},
  all_private_articles: {},
  article_by_tag: [],
  article_by_category: [],
  article_by_link:[],
  article_loading: false,
  addLikeLoading:false,
  loading: false,
  draft: {
    saving: false,
    savedAt: null,
    error: null,
    currentId: null,
  },
};

export default function articleReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ARTICLES_BY_CATEGORY:
      return {
        ...state,
        article_by_category: [...action.payload],
      };
    case GET_ARTICLES_BY_TAG:
      return {
        ...state,
        article_by_tag: [...action.payload],
      };

    case GET_ARTICLE_BY_LINK:
      return {
        ...state,
        article_by_link:[...action.payload]
      };

    case PUBLIC_DETAILS_ARTICLE:
      return {
        ...state,
        public_article_details: action.payload,
        loading: false,
      };

    case ARTICLES_LOADING:
      return {
        ...state,
        loading: true,
      };
    
    case ADD_LIKE:
      return {
        ...state,
        article_by_link: state.article_by_link.map((a) =>
          a._id === action.payload._id ? action.payload : a
        ),
      };
    case TOGGLE_LIKE_ADDING:
        return{
          ...state,
          addLikeLoading: !state.addLikeLoading
        };
    case ADMIN_DETAILS_ARTICLE:
      return {
        ...state,
        admin_article_details: action.payload,
      };
    case GET_PUBLIC_ARTICLES:
      return {
        ...state,
        all_public_articles: action.payload,
        loading:false
      };
    case GET_PRIVATE_ARTICLES:
      return {
        ...state,
        all_private_articles: action.payload,
      };
    case TOGGLE_ARTICLE:
      return {
        ...state,
        article_loading: !state.article_loading,
      };
    case SAVE_DRAFT_START:
      return {
        ...state,
        draft: { ...state.draft, saving: true, error: null },
      };
    case SAVE_DRAFT_SUCCESS:
      return {
        ...state,
        draft: {
          saving: false,
          savedAt: action.payload?.draftSavedAt || new Date().toISOString(),
          error: null,
          currentId: action.payload?._id || state.draft.currentId,
        },
      };
    case SAVE_DRAFT_ERROR:
      return {
        ...state,
        draft: { ...state.draft, saving: false, error: action.payload },
      };
    case PUBLISH_DRAFT:
      return {
        ...state,
        draft: { saving: false, savedAt: null, error: null, currentId: null },
      };
    case LINK_ARTICLES:
    case UNLINK_ARTICLES: {
      const fromUpdated = action.payload?.from;
      if (!fromUpdated) return state;
      const current = Array.isArray(state.admin_article_details) ? state.admin_article_details : [];
      if (current.length && current[0]?.id?.toString() === fromUpdated._id?.toString()) {
        const merged = [
          { ...current[0], linkedArticles: fromUpdated.linkedArticles },
          ...current.slice(1),
        ];
        return { ...state, admin_article_details: merged };
      }
      return state;
    }
    default:
      return state;
  }
}
